
export const validateCreateReviewForm = (payload: any) => {
    let errors: any = [];

    let payloadToValidate = {
        ...payload
    };

    let ratings = payloadToValidate.ReviewRating;
    const overallRating = ratings.find((rating: any) => rating.RatingTypeID === 6);

    ratings = ratings.filter((rating: any) => rating.RatingTypeID !== 6);

    payloadToValidate.ReviewRating = ratings;
    payloadToValidate.ReviewRatingOverall = overallRating;

    Object.keys(payloadToValidate).forEach((key: any) => {
        const value = payloadToValidate[key];

        if (key === "ReviewTitle" && (!value || !value.length)) {
            errors.push({
                key: 'ReviewTitle',
                message: <>Please provide a Title for the Review. <button type="button" className="btn btn-sm btn-primary p-1" onClick={() => {document.getElementById('ReviewTitle')?.focus()}}>Go to input</button></>
            }); 
        }

        if (key === "ReviewerFirstName" && (!value || !value.length)) {
            errors.push({
                key: 'ReviewerFirstName',
                message: <>Please provide a First Name for the Review. <button type="button" className="btn btn-sm btn-primary p-1" onClick={() => {document.getElementById('ReviewerFirstName')?.focus()}}>Go to input</button></>
            }); 
        }

        if (key === "ReviewerLastName" && (!value || !value.length)) {
            errors.push({
                key: 'ReviewerLastName',
                message: <>Please provide a Last Name for the Review. <button type="button" className="btn btn-sm btn-primary p-1" onClick={() => {document.getElementById('ReviewerLastName')?.focus()}}>Go to input</button></>
            }); 
        }

        if (key === "ReviewerEmailAddress" && (!value || !value.length || !validateEmail(value))) {
            errors.push({
                key: 'ReviewerEmailAddress',
                message:<>Please provide a valid Email Address for the Review. <button type="button" className="btn btn-sm btn-primary p-1" onClick={() => {document.getElementById('ReviewerEmailAddress')?.focus()}}>Go to input</button></>
        }); 
        }

        if (key === "ReviewerTelephoneNumber" && (!value || !value.length || !validateTelephone(value))) {
            errors.push({
                key: 'ReviewerTelephoneNumber',
                message: <>Please provide a valid Telephone Number for the Review. <button type="button" className="btn btn-sm btn-primary p-1" onClick={() => {document.getElementById('ReviewerTelephoneNumber')?.focus()}}>Go to input</button></>
            }); 
        }

        if (key === "ReviewerDisplayName" && (!value || !value.length)) {
            errors.push({
                key: 'ReviewerDisplayName',
                message: <>Please provide a Display Name for the Review. <button type="button" className="btn btn-sm btn-primary p-1" onClick={() => {document.getElementById('ReviewerDisplayName')?.focus()}}>Go to input</button></>
            }); 
        }

        if (key === "ReviewContent") {
            if (!value || !value.length) {
                errors.push({
                    key: 'ReviewContent',
                    message: <>Please enter your Review <button type="button" className="btn btn-sm btn-primary p-1" onClick={() => {document.getElementById('ReviewContent')?.focus()}}>Go to input</button></>
                });
            }

            if (value && value.length > 1000) {
                errors.push({
                    key: 'ReviewContent',
                    message: <>Please enter less than 1000 characters <button type="button" className="btn btn-sm btn-primary p-1" onClick={() => {document.getElementById('ReviewContent')?.focus()}}>Go to input</button></>
                });
            }

            if (value && value.length < 200) {
                errors.push({
                    key: 'ReviewContent',
                    message: <>Please use more than 200 characters for the review comment <button type="button" className="btn btn-sm btn-primary p-1" onClick={() => {document.getElementById('ReviewContent')?.focus()}}>Go to input</button></>
                });
            }
        }

        if (key === "ExperienceTypeID" && !value) {
            errors.push({
                key: 'ExperienceTypeID',
                message: <>Please choose the Experience that relates to the Review. <button type="button" className="btn btn-sm btn-primary p-1" onClick={() => {document.getElementById('ExperienceTypeID')?.focus()}}>Go to input</button></>
            }); 
        }

        if (Number(payload['ExperienceTypeID']) === 4 && key === 'ReviewerConnectionID' && !value) {
            errors.push({
                key: 'ReviewerConnectionID',
                message: <>Please choose the Connection that relates to the Review. <button type="button" className="btn btn-sm btn-primary p-1" onClick={() => {document.getElementById('ReviewerConnectionID')?.focus()}}>Go to input</button></>
            });
        }

        if (key === 'ReviewRatingOverall' && !value) {
            errors.push({
                key: 'ReviewRatingOverall',
                message: <>Please select an Overall Rating. <button type="button" className="btn btn-sm btn-primary p-1" onClick={() => {document.getElementById('ReviewRatingOverall')?.focus()}}>Go to input</button></>
            });
        }

        if (key === 'ReviewRating' && (!value || value.length < 7)) {
            errors.push({
                key: 'ReviewRating',
                message: <>
                    Please complete all Ratings. <button
                    type="button"
                    className="btn btn-sm btn-primary p-1"
                    onClick={() => {document.getElementById('ReviewRating')?.focus()}}
                >Go to input</button>
                </>
            });
        }

        if (key === 'MemberCategoryID' && !value) {
            errors.push({
                key: 'MemberCategoryID',
                message: <>Please choose a Category of Care. <button type="button" className="btn btn-sm btn-primary p-1" onClick={() => {document.getElementById('MemberCategoryID')?.focus()}}>Go to input</button></>
            });
        }
    });

    const terms: any = document.getElementById('Terms');

    if (terms && !terms.checked) {
        errors.push({
            key: 'Terms',
            message: <>Please accept our Terms and Conditions. <button type="button" className="btn btn-sm btn-primary p-1" onClick={() => {document.getElementById('Terms')?.focus()}}>Go to input</button></>
        });
    }

    const sortedErrors = errors.sort((a: any, b: any) => {
        const aElScrollTop = document.getElementById(a.key) ? (window.pageYOffset + document.getElementById(a.key).getBoundingClientRect().top) : null;
        const bElScrollTop = document.getElementById(b.key) ? (window.pageYOffset + document.getElementById(b.key).getBoundingClientRect().top) : null;

        return (aElScrollTop < bElScrollTop) ? -1 : 1;
    });

    return sortedErrors;
}

export const validateEmail = (email: string) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
}

export const validateTelephone = (telephone: any) => {
    const re = /[0-9\+()\-\s]/;
    return telephone.length < 14 && re.test(telephone);
}
